import type { Size } from '@lendi-ui/checkbox';

import { FIELD_PATHS } from '@funnels/constants';
import { CompanyEntityIndex } from '@funnels/types';

import { CheckboxField } from '../../Fields';

interface ForeignCompanyProps extends CompanyEntityIndex {
  size?: Size;
  isChecked?: boolean;
  isDisabled?: boolean;
}

export const ForeignCompany = (props: ForeignCompanyProps) => {
  const { companyIndex, size = 'sm', ...rest } = props;

  return (
    <CheckboxField
      {...rest}
      name={FIELD_PATHS.COMPANY_FOREIGN_COMPANY(companyIndex)}
      size={size}
      checkboxLabel="Foreign company"
    />
  );
};
